// extracted by mini-css-extract-plugin
module.exports = {"pressable":"Pressable_pressable__MmHyH"};